const BACK_OFFICE_MASTER_DATA_URL = "/master-data/vat-posting-group";

export default [
  {
    level:3,
    key: "title.vatProductPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/vat-product-posting-group`,
  },
   {
    level:3,
    key: "title.vatBusinessPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/vat-business-posting-group`,
  },
  {
    level:3,
    key: "title.vatPostingSetup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/vat-posting-setup`,
  }
];
